
export class Message {

	id = "";
	text = "";
	textPerLine: string[] = [];
	timestamp: null|number = null;
	senderId = "";
	files: ChatFile[] = [];
	chatId = "";
	msgRepliedToId = "";
	msgRepliedToTxt = "";
	msgRepliedToSenderId = "";

}

export enum ChatType { direct, userGroup, systemGroup };

export class Chat {

	id = "";
	title = "";
	chatType = ChatType.direct;
	sourceId = "";

	lastMsg = "";
	lastMsgTms: number|null = null;
	lastMsgTmsStr = "";
	messages: Message[] = [];

	bNewMsg = false;
	
	bNotifications = false;

}

export class ChatBackend {

	chId = "";
	title = "";

	cgId = "";
	vgId = "";
	empfaengerEbeId = "";

	lastMessagePreview = "";
	chLetzteNachricht: number|null = null;
	zuletztGesehen: number|null = null;

	nachrichten: PageChatNachrichten|null = null;

	anlageBenutzer = "";

	chbErinnerungsmail = false;

}

export class PageChatNachrichten {

	totalPages = 0;
	totalElements = 0;
	size = 0;
	content: ChatNachrichten[] = [];

}

export class ChatNachrichten {

	cnId = "";
	chId = "";
	text = "";
	absenderId = "";
	dateien: ChatDateien[] = [];
	anlageDatum: number|null = null;
	originalCnId = "";
	originalNachricht: ChatNachrichten|null = null;

}

export class ChatDateien {

	dateiId = "";
	dateiName = "";
	dateiVerzeichnis = "";
	veranstaltungId	= "";
	austauschId	= "";
	nachrichtenId = "";
	chatId = "";
	dateiDaten = "";

}

export class ChatGroup {

	id = "";
	users: string[] = [];
	title = "";
	bSystem = false;
	bAdmin = false;

}

export class ChatGroupBackend {
	cgId = "";
	cgName = "";
	chatgruppeBenutzern: ChatgruppeBenutzer[]|null = [];
}

export class ChatFile {

	id = "";
	file: File|null = null;
	fileName = "";

}


export class ChatgruppeBenutzer {
	cgbId = "";
	cgId = "";
	ebeId = "";
	cgAdmin = false;
	name = "";
}

